import type { ReactNode, RefObject } from 'react'

type TrayScrollRootProps = {
  /** The tray's scroll container, also the scroll root its `useTrayLazyWindow` observes. */
  scrollRootRef?: RefObject<HTMLDivElement | null>
  children: ReactNode
}

/**
 * The scroll container every right-panel tray body sits in (`TrayPanelLayout`, Portraits).
 *
 * [scrollbar-gutter:stable] reserves the scrollbar's width here, on the actual scroller (not the
 * shared PanelShell wrapper it sits inside), so it stays constant whether or not results currently
 * overflow, instead of the content narrowing the moment a real scrollbar appears. No extra right
 * padding is needed: the reserved gutter supplies that inset on its own, matching the left inset
 * the parent's `pl-4` already provides.
 */
export function TrayScrollRoot({ scrollRootRef, children }: TrayScrollRootProps) {
  return (
    <div
      ref={scrollRootRef}
      className="flex min-h-0 min-w-0 flex-1 flex-col overflow-x-hidden overflow-y-auto [scrollbar-gutter:stable]"
    >
      {children}
    </div>
  )
}
